import { render } from "./LottoOddsInfo.vue?vue&type=template&id=48363da8&scoped=true"
import script from "./LottoOddsInfo.vue?vue&type=script&lang=js"
export * from "./LottoOddsInfo.vue?vue&type=script&lang=js"

import "./LottoOddsInfo.vue?vue&type=style&index=0&id=48363da8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48363da8"]])

export default __exports__